import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import WunderflatsStats from "../../../../../../../components/WunderflatsStats/WunderflatsStats";
import { useI18n } from "../../../../../context/I18nContext";

const propTypes = {
  getStats: PropTypes.func, // client-only
};

const Statistics = ({ getStats }) => {
  const { t } = useI18n();
  const [stats, setStats] = useState({
    listings: -1,
    rents: -1,
    companies: -1,
  });

  useEffect(() => {
    const fetchStats = async () => {
      const { stats } = await getStats();
      setStats(stats);
    };

    fetchStats();
  }, [getStats]);

  return (
    <section className="LandingPage-Statistics">
      <WunderflatsStats
        t={t}
        listings={stats.listings}
        rents={stats.rents}
        companies={stats.companies}
      />
    </section>
  );
};

Statistics.propTypes = propTypes;
export default Statistics;
